import { useEffect, useState } from 'react';
import '../../App.css'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../../redux/slice/auth/authSlice';
import { fetchSportsEvents, fetchSportsEventsBeforeLogin } from '../../redux/slice/events/eventsSlice';
import Appconfig from '../../config/config'
import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import Loader from 'components/loader';
// export const sidebarItems = [
//     {
//         title: 'In-Play',
//         icon: '/assets/images/inplay.png',
//         url: '/inplay'
//     },
//     {
//         title: 'WPL 2025',
//         icon: '/assets/images/icc.png',
//         url: '/wplwinner'
//     },
//     {
//         title: 'ICC Champions 2025',
//         icon: '/assets/images/icc.png',
//         url: '/icc2025'
//     },
//     {
//         title: 'Cricket',
//         icon: '/assets/images/cricket.png',
//         // subItems: [
//         //     {
//         //         title: 'West Indies Championship, 2025',
//         //         matches: [
//         //             { title: 'Barbados V Jamaica' }
//         //         ]
//         //     },
//         //     {
//         //         title: 'One Day Internationals',
//         //         matches: [
//         //             { title: 'Zimbabwe v Ireland' },
//         //             { title: 'Sri Lanka v Australia' },
//         //             { title: 'New Zealand v Pakistan' }
//         //         ]
//         //     },
//         //     {
//         //         title: 'ICC Champions Trophy',
//         //         matches: [
//         //             { title: 'India v England' },
//         //             { title: 'Australia v South Africa' }
//         //         ]
//         //     }
//         // ]
//         subItems: cricketEvents?.map(event => ({
//             title: event?.event_name
//         })) || []

//     },
//     {
//         title: 'Soccer',
//         icon: '/assets/images/soccer.png',
//         subItems: [
//             {
//                 title: 'Premier League',
//                 matches: [
//                     { title: 'Manchester United v Liverpool' },
//                     { title: 'Chelsea v Arsenal' }
//                 ]
//             },
//             {
//                 title: 'Champions League',
//                 matches: [
//                     { title: 'Real Madrid v Barcelona' },
//                     { title: 'Bayern Munich v PSG' }
//                 ]
//             }
//         ]
//     },
//     {
//         title: 'Tennis',
//         icon: '/assets/images/tennis.png',
//         subItems: [
//             {
//                 title: 'ATP Tour',
//                 matches: [
//                     { title: 'Novak Djokovic v Rafael Nadal' },
//                     { title: 'Roger Federer v Andy Murray' }
//                 ]
//             }
//         ]
//     },
//     {
//         title: 'LudoCricket',
//         icon: '/assets/images/poker.png',
//         url: '/ludocricket'
//     },
//     {
//         title: 'Indian Poker',
//         icon: '/assets/images/poker.png',
//         url: '/royalcasino'
//     },
//     {
//         title: 'Indian Poker II',
//         icon: '/assets/images/poker-2.png',
//         url: '/indianpoker'
//     },
//     {
//         title: 'Aviator',
//         icon: '/assets/svg/aviator.svg',
//         url: '/spribe'
//     },
//     {
//         title: 'AE Sexy',
//         icon: '/assets/images/poker.png',
//         url: '/aesexybcrt'
//     },
//     {
//         title: 'Evolution',
//         icon: '/assets/svg/casino-icon.svg',
//         url: '/evolution'
//     },
//     {
//         title: 'Live Casino',
//         icon: '/assets/images/poker.png',
//         url: '/livecasino'
//     },
//     {
//         title: 'Vivo',
//         icon: '/assets/svg/casino-icon.svg',
//         url: '/vivo'
//     },
//     {
//         title: 'Betgames',
//         icon: '/assets/svg/casino-icon.svg',
//         url: '/betgames'
//     },
//     {
//         title: 'Casino III',
//         icon: '/assets/images/poker.png',
//         url: '/casino3'
//     },
// ];

export const mainMenu = [
    {
        title: 'Account Statement',
        icon: '/assets/svg/Account-Statement.svg',
        url: '/accountstatement',
        type: 'all'
    },
    {
        title: 'Market Analysis',
        icon: '/assets/svg/profit-loss-report.svg',
        url: '/market-analysis',
        type: 'all'
    },
    {
        title: ' Profit Loss Report',
        icon: '/assets/svg/profit-loss-report.svg',
        url: '/profitloss',
        type: 'all'
    },
    {
        title: 'Bet Histroy',
        icon: '/assets/svg/bet-history.svg',
        url: '/bethistroy',
        type: 'all'
    },
    {
        title: 'Unsettled Bet',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/unsettledbet',
        type: 'all'
    },
    {
        title: 'Chip Summary',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/chipsummary',
        type: 'admins'
    },
    {
        title: 'Client P L',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/clientpl',
        type: 'admins'
    },
    {
        title: 'Market P L',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/marketpl',
        type: 'admins'
    },
    {
        title: 'Sport P L',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/sportpl',
        type: 'admins'
    },
    {
        title: 'Match P L',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/matchpl',
        type: 'admins'
    },
    {
        title: 'Fancy Sale',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/fancy-sale',
        type: 'admins'
    },
    {
        title: 'Match Sale',
        icon: '/assets/svg/unsettle-bet.svg',
        url: '/match-sale',
        type: 'admins'
    },
    {
        title: 'Set Button Value',
        icon: '/assets/svg/set-button-value.svg',
        url: '/userprofile',
        type: 'all'
    },
    {
        title: 'Rules',
        icon: '/assets/svg/rules.svg',
        url: '/rules',
        type: 'all'
    },
    {
        title: 'Change Password',
        icon: '/assets/svg/change-password.svg',
        url: '/changepassword',
        type: 'all'
    },
    {
        title: 'Results',
        icon: '/assets/svg/result.svg',
        url: '/result',
        type: 'all'
    },
    {
        title: 'Logout',
        icon: '/assets/svg/log-out.svg',
        isLogout: true,
        type: 'all'
    },
]

function LeftSidebar({ setLeftMenu }) {
    const { cricketEvents, soccerEvents, tennisEvents, loading, events } = useSelector((state) => state.events);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [openMenus, setOpenMenus] = useState({});
    const [subMenu, setSubMenu] = useState({});
    const [Loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const sidebarItems = [
        {
            title: 'In-Play',
            icon: '/assets/images/inplay.png',
            url: '/inplay'
        },
        {
            title: 'IPL 2025',
            icon: '/assets/images/icc.png',
            url: '/ipl'
        },
        // {
        //     title: 'ICC Champions 2025',
        //     icon: '/assets/images/icc.png',
        //     url: '/icc2025'
        // },
        {
            title: 'Cricket',
            icon: '/assets/images/cricket.png',
            // subItems: [
            //     {
            //         title: 'West Indies Championship, 2025',
            //         matches: [
            //             { title: 'Barbados V Jamaica' }
            //         ]
            //     },
            //     {
            //         title: 'One Day Internationals',
            //         matches: [
            //             { title: 'Zimbabwe v Ireland' },
            //             { title: 'Sri Lanka v Australia' },
            //             { title: 'New Zealand v Pakistan' }
            //         ]
            //     },
            //     {
            //         title: 'ICC Champions Trophy',
            //         matches: [
            //             { title: 'India v England' },
            //             { title: 'Australia v South Africa' }
            //         ]
            //     }
            // ]
            subItems: cricketEvents?.map(event => ({
                title: event?.event_name,
                id: event?.event_id
            })) || []

        },
        {
            title: 'Soccer',
            icon: '/assets/images/soccer.png',
            subItems: soccerEvents?.map(event => ({
                title: event?.event_name,
                id: event?.event_id
            })) || []
        },
        {
            title: 'Tennis',
            icon: '/assets/images/tennis.png',
            subItems: tennisEvents?.map(event => ({
                title: event?.event_name,
                id: event?.event_id
            })) || []
        },
        // {
        //     title: 'LudoCricket',
        //     icon: '/assets/images/poker.png',
        //     url: '/ludocricket'
        // },
        {
            title: 'Indian Poker',
            icon: '/assets/images/poker.png',
            url: '/royalcasino'
        },
        {
            title: 'Indian Poker II',
            icon: '/assets/images/poker-2.png',
            url: '/indianpoker'
        },
        {
            title: 'Aviator',
            icon: '/assets/svg/aviator.svg',
            url: '/spribe'
        },
        {
            title: 'AE Sexy',
            icon: '/assets/images/poker.png',
            url: '/aesexybcrt'
        },
        {
            title: 'Evolution',
            icon: '/assets/svg/casino-icon.svg',
            url: '/evolution'
        },
        {
            title: 'Live Casino',
            icon: '/assets/images/poker.png',
            url: '/livecasino'
        },
        // {
        //     title: 'Vivo',
        //     icon: '/assets/svg/casino-icon.svg',
        //     url: '/vivo'
        // },
        // {
        //     title: 'Betgames',
        //     icon: '/assets/svg/casino-icon.svg',
        //     url: '/betgames'
        // },
        {
            title: 'Casino III',
            icon: '/assets/images/poker.png',
            url: '/casino3'
        },
    ];


    const downlineListItem = {
        'title': 'Downline List ',
        'url': '',
        'routerId': ['/list/user', '/list/master'],
        'submenu': Appconfig.userTypes.slice(Appconfig.userTypes.findIndex(userType => userType?.title == userdata?.user_type) + 1)?.map(userType => ({
            title: userType?.title,
            url: `list/${profileData?._id}/${userType?.title}`
        })) || []
    };
    // const downlineListItem = {
    //     'title': 'Downline List ',
    //     'url': '',
    //     'routerId': ['/list/user', '/list/master'],
    //     'submenu': [
    //         { 'title': 'User Downline List', 'url': '/list/user' },
    //         // { 'title': 'Master Downline List', 'url': '/list/master' }
    //     ]
    // };

    const initialNavItems = [
        {
            'title': 'Dashboard ',
            'url': '/dashboard',
            'routerId': ['/dashboard'],
        },
        downlineListItem,
        {
            'title': 'My Account ',
            'url': '/my-account',
            'routerId': ['/my-account'],
        },
        {
            'title': 'My Report',
            'url': '',
            'routerId': ['/reports/profit-loss', '/reports/downline-pl'],
            'submenu': [
                {
                    'title': 'Account Statement ',
                    'url': '/accountstatement'
                },
                {
                    'title': 'Market Analysis ',
                    'url': '/market-analysis'
                },
                {
                    'title': 'Profit Loss Report ',
                    'url': '/profitloss'
                },
                {
                    'title': 'Bet Histroy ',
                    'url': '/bethistroy'
                },
                {
                    'title': 'Client P L ',
                    'url': '/clientpl'
                },
                {
                    'title': 'Market P L ',
                    'url': '/marketpl'
                },
                {
                    'title': 'Sport P L ',
                    'url': '/sportpl'
                },
                {
                    'title': 'Match P L ',
                    'url': '/matchpl'
                },
                {
                    'title': 'Chip Summary',
                    'url': '/chipsummary'
                }

            ]
        },
        // {
        //     'title': 'BetList ',
        //     'url': '/bet-list',
        //     'routerId': ['/bet-list'],
        // },
        {
            'title': 'Market Analysis ',
            'url': '/market-analysis',
            'routerId': ['/market-analysis'],
        },
        {
            'title': 'Banking',
            'url': '',
            'routerId': ['/user-banking', '/master-banking'],
            'submenu': [
                {
                    'title': 'User Banking',
                    'url': '/user-banking'
                },
                // {
                //     'title': 'Master Banking',
                //     'url': '/master-banking'
                // },
            ]
        },
        // {
        //     'title': 'Commission ',
        //     'url': '/commission',
        //     'routerId': ['/commission'],
        // },
        {
            'title': 'Password History',
            'url': '/password-history',
            'routerId': ['/password-history'],
        },
        // {
        //     'title': 'Restore User ',
        //     'url': '/restore-user',
        //     'routerId': ['/restore-user'],
        // },
    ];
    let navItems = [...initialNavItems];

    const downlineListItem1 = {
        'title': 'Downline List ',
        'url': '',
        'routerId': ['/list/user', '/list/master'],
        'submenu': [
            {
                'key': '1',
                'label': (
                    <Link to={'/list/user'}>
                        User Downline List
                    </Link>
                ),
                'url': '/list/user'
            },
            // {
            //     'key': '2',
            //     'label': (
            //         <Link to={`/list/master`}>
            //             Master Downline List
            //         </Link>
            //     ),
            //     'url': '/list/master'
            // }
        ]
    };

    const initialNavItemsForMobile = [
        {
            'title': 'Dashboard ',
            'url': '/dashboard',
            'routerId': ['/dashboard'],
        },
        downlineListItem1,
        {
            'title': 'My Account ',
            'url': '/my-account',
            'routerId': ['/my-account'],
        },
        // {
        //     'title': 'My Report',
        //     'url': '',
        //     'routerId': ['/reports/profit-loss', '/reports/downline-pl'],
        //     'submenu': [
        //         {
        //             key: '1',
        //             label: (
        //                 <Link to={'/reports/profit-loss'}>
        //                     Event Profit/Loss
        //                 </Link>
        //             ),
        //             'url': '/reports/profit-loss'
        //         },
        //         {
        //             key: '2',
        //             label: (
        //                 <Link to={'/reports/downline-pl'}>
        //                     Downline Profit/Loss
        //                 </Link>
        //             ),
        //             'url': '/reports/downline-pl'
        //         },
        //     ]
        // },
        // {
        //     'title': 'BetList ',
        //     'url': '/bet-list',
        //     'routerId': ['/bet-list'],
        // },
        {
            'title': 'Market Analysis ',
            'url': '/market-analysis',
            'routerId': ['/market-analysis'],
        },
        {
            'title': 'Banking',
            'url': '',
            'routerId': ['/user-banking', '/master-banking'],
            'submenu': [
                {
                    key: '1',
                    label: (
                        <Link to={'/user-banking'}>
                            User Banking
                        </Link>
                    ),
                    'url': '/user-banking'
                },
                // {
                //     key: '2',
                //     label: (
                //         <Link to={'/master-banking'}>
                //             Master Banking
                //         </Link>
                //     ),
                //     'url': '/master-banking'
                // },
            ]
        },
        // {
        //     'title': 'Commission ',
        //     'url': '/commission',
        //     'routerId': ['/commission'],
        // },
        {
            'title': 'Password History',
            'url': '/password-history',
            'routerId': ['/password-history'],
        },
        // {
        //     'title': 'Restore User ',
        //     'url': '/restore-user',
        //     'routerId': ['/restore-user'],
        // },
    ]

    let navItemsForMobile = [...initialNavItemsForMobile];

    // if (['Managment', 'Administrative'].includes(userdata?.user_type)) {
    navItems.push(
        {
            'title': 'Restore User ',
            'url': '/restore-user',
            'routerId': ['/restore-user'],
        },
        {
            'title': 'My Setting',
            'url': '',
            'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/block-event-types`, `/event-user-general-setting`, `/add-domain`, `/betting`, `/banner`, `/manual-odds`],
            'submenu': [
                (['Managment', 'Administrative'].includes(userdata?.user_type) &&
                {
                    'title': 'Admin Fund ',
                    'url': '/adminfund'
                }),
                {
                    'title': 'News ',
                    'url': '/news'
                },
                {
                    'title': 'User General Setting ',
                    'url': `/user-general-setting/${profileData?._id}`
                },
                {
                    'title': 'Block Market ',
                    'url': '/block-event-types'
                },
                {
                    'title': 'Event Wise Setting ',
                    'url': `/event-user-general-setting`
                },
                // {
                //     'title': 'Add Domain ',
                //     'url': `/add-domain`
                // },
                {
                    'title': 'Betting ',
                    'url': `/betting`
                },
                {
                    'title': 'Add Banner ',
                    'url': `/banner`
                },
                // {
                //     'title': 'Manual Odds ',
                //     'url': `/manual-odds`
                // },
            ]
        });
    navItemsForMobile.push(
        {
            'title': 'My Setting',
            'url': '',
            'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/event-user-general-setting`, `/add-domain`],
            'submenu': [
                {
                    key: '1',
                    label: (
                        <Link to={'/adminfund'}>
                            Admin Fund
                        </Link>
                    ),
                    'url': '/adminfund'
                },
                {
                    key: '2',
                    label: (
                        <Link to={'/news'}>
                            News
                        </Link>
                    ),
                    'url': '/news'
                },
                {
                    key: '3',
                    label: (
                        <Link to={`/user-general-setting/${profileData?._id}`}>
                            User General Setting
                        </Link>
                    ),
                    'url': `/user-general-setting/${profileData?._id}`
                },
                {
                    key: '4',
                    label: (
                        <Link to={'/block-event-types'}>
                            Block Market
                        </Link>
                    ),
                    'url': '/block-event-types'
                },
                {
                    key: '5',
                    label: (
                        <Link to={'/event-user-general-setting'}>
                            Event Wise User General Setting
                        </Link>
                    ),
                    'url': `/event-user-general-setting`
                },
                {
                    key: '6',
                    label: (
                        <Link to={'/add-domain'}>
                            Add Domain
                        </Link>
                    ),
                    'url': '/add-domain'
                },
                {
                    key: '7',
                    label: (
                        <Link to={'/betting'}>
                            Betting
                        </Link>
                    ),
                    'url': '/betting'
                },
                {
                    key: '8',
                    label: (
                        <Link to={'/banner'}>
                            Add Banner
                        </Link>
                    ),
                    'url': '/banner'
                },
                {
                    key: '9',
                    label: (
                        <Link to={'/manual-odds'}>
                            Manual Odds
                        </Link>
                    ),
                    'url': '/manual-odds'
                },
            ]
        },
    )
    // }

    // if (userdata?.user_type === 'Admin') {
    //     navItems.push({
    //         'title': 'Extra',
    //         'url': '',
    //         'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`],
    //         'submenu': [
    //             {
    //                 'title': 'News',
    //                 'url': '/news'
    //             },
    //             {
    //                 'title': 'Add Banner',
    //                 'url': `/banner`
    //             },
    //             {
    //                 'title': 'User General Setting',
    //                 'url': `/user-general-setting/${profileData?._id}`
    //             },
    //             {
    //                 'title': 'Event Wise Setting ',
    //                 'url': `/event-user-general-setting`
    //             },
    //             {
    //                 'title': 'Block Market ',
    //                 'url': '/block-event-types'
    //             },
    //             {
    //                 'title': 'Admin Fund ',
    //                 'url': '/adminfund'
    //             },
    //         ]
    //     });
    //     navItemsForMobile.push(
    //         {
    //             'title': 'Extra',
    //             'url': '',
    //             'routerId': ['/adminfund', '/news', `/user-general-setting/${profileData?._id}`, `/event-user-general-setting`],
    //             'submenu': [
    //                 {
    //                     key: '2',
    //                     label: (
    //                         <Link to={'/news'}>
    //                             News
    //                         </Link>
    //                     ),
    //                     'url': '/news'
    //                 },
    //                 {
    //                     key: '8',
    //                     label: (
    //                         <Link to={'/banner'}>
    //                             Add Banner
    //                         </Link>
    //                     ),
    //                     'url': '/banner'
    //                 },
    //                 {
    //                     key: '10',
    //                     label: (
    //                         <Link to={`/user-general-setting/${profileData?._id}`}>
    //                             User General Setting
    //                         </Link>
    //                     ),
    //                 },
    //             ]
    //         },
    //     )
    // }

    const toggleMenu = (title) => {
        setOpenMenus(prev => ({
            ...prev,
            [title]: !prev[title]
        }));
    };

    const toggleSubMenu = (title) => {
        setSubMenu(prev => ({
            ...prev,
            [title]: !prev[title]
        }));
    }

    const handleLogout = (item) => {
        if (item.isLogout) {
            dispatch(logout());
            navigate('/');
            setLeftMenu(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchSportsEvents());
        }
        else {
            dispatch(fetchSportsEventsBeforeLogin())
        }
    }, [isAuthenticated, dispatch]);

    function CreateAndLaunchWCOCasino(provider_code, game_code, type) {
        if (!isAuthenticated) {
            NotificationManager.error('Please login to play.', '', 1000);
            return;
        }
        setLoading(true);
        if (profileData?.is_casino_bet_lock == 'Yes') {
            NotificationManager.error('Casino Block By Upline.', '', 1000);
            setLoading(false);
            return;
        }
        const userData = {
            user_id: profileData?._id,
            user_name: profileData?.user_name,
            redirect_url: window.location.href,
            provider_code: provider_code,
            game_code: game_code,
            type: type,
        };

        var config = {
            method: "post",
            url: `${Appconfig.casinoUrl}wco/login`,
            headers: {
                "Content-Type": "application/json",
            },

            data: JSON.stringify(userData),
        };

        axios(config)
            .then(function (response) {
                let status = response.data.status?.code;
                console.log('status:', status)
                if (status === "SUCCESS") {
                    window.open(response.data.launchURL, "_self");
                    setLoading(false);
                }

                if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
                    NotificationManager.error('Game Not Found.', '', 1000);
                    setLoading(false);
                } else if (status == "AUTHENTICATION_FAILED") {
                    NotificationManager.error(response.data.status?.message, '', 1000);
                    setLoading(false);
                }
                if (status == "LOGIN_FAILED") {
                    NotificationManager.error(response?.data?.status?.message, '', 1000);
                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }
    return (
        <>
            <div className='overflow-x-hidden [scrollbar-width:none] overflow-y-auto bg-[#fff] h-auto relative sub_path over-wrap sidebar-ul'>
                <ul className='pb-[2px] overflow-y-auto'>

                    {

                        !userdata || userdata?.user_type === 'User' ?
                            mainMenu.some(menu => window.location.pathname.includes(menu.url)) ? (
                                <>
                                    <p className='bg-[#27a6c3] text-[#fff] text-[14px] font-bold capitalize py-[2px] px-[7px]'>
                                        Main Menu
                                        <button type='button' onClick={() => setLeftMenu(false)} className='float-right'>
                                            <i className="fa fa-close pt-1 icon-toggle-right  lg:hidden float-right"></i>
                                        </button>
                                    </p>
                                    {
                                        mainMenu.filter(item => item?.type !== 'admins').map((item, index) => (
                                            <li key={index} className='sidebar-li'>
                                                {!item.isLogout ? (
                                                    <a
                                                        className={`text-[#045662] border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold`}
                                                        aria-expanded="true"
                                                        href={item.url}
                                                    >
                                                        <img
                                                            className={item.icon.endsWith('.svg') ? 'w-[18px] mr-[5px]' : 'w-[28px] mr-1'}
                                                            src={item.icon}
                                                        />
                                                        {item.title}
                                                    </a>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleLogout(item)}
                                                        className={`text-[#045662] border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold w-full text-left`}
                                                    >
                                                        <img
                                                            className={item.icon.endsWith('.svg') ? 'w-[18px] mr-[5px]' : 'w-[28px] mr-1'}
                                                            src={item.icon}
                                                            alt={item.title}
                                                        />
                                                        {item.title}
                                                    </button>
                                                )}
                                            </li>
                                        ))
                                    }
                                </>
                            )


                                : (
                                    <>
                                        <p className='bg-[#27a6c3] text-[#fff] text-[14px] font-bold capitalize py-[2px] px-[7px]'>
                                            Popular
                                            <button type='button' onClick={() => setLeftMenu(false)} className='float-right'>
                                                <i className="fa fa-close pt-1 icon-toggle-right  lg:hidden  float-right"></i>
                                            </button>
                                        </p>
                                        {sidebarItems.map((item, index) => (
                                            <li key={index} className='sidebar-li'>
                                                {item.subItems ? (
                                                    <>
                                                        <a onClick={() => toggleMenu(item.title)} className="dropdown-toggle text-[#045662]  border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold capitalize" >
                                                            <img className='w-[28px] mr-1' src={item.icon} />
                                                            {item.title}
                                                        </a>
                                                        {
                                                            openMenus[item.title] &&
                                                            <div className='block' id="cricketSubmenu">
                                                                <div className='bg-[#e1e4ef] text-[12px] py-[2px] px-[5px]'>
                                                                    <ul className=''>
                                                                        {item?.subItems?.map((subItem, index) => (
                                                                            <li key={index} className='ml-[15px]' onClick={() => toggleSubMenu(subItem.title)}>
                                                                                <div className='relative pt-[4px] overflow-ellipsis whitespace-nowrap overflow-hidden align-middle'>
                                                                                    <span className='uppercase font-[monospace] text-[0.6em] align-middle mr-0'></span>
                                                                                    <span >
                                                                                        <span className="text-[11px] text-[rgb(0,_0,_0)] cursor-pointer !border-[#274396] border-l-[1px] !pt-[4px] !pr-[0] !pb-[0] !pl-[10px] table-caption !whitespace-normal w-[125px]"
                                                                                            onClick={() => {
                                                                                                navigate(`/event/${item?.title == 'Cricket' ? 4 : item?.title == 'Soccer' ? 1 : 2}/${subItem?.id}`)
                                                                                                setLeftMenu(false)
                                                                                                setOpenMenus({})
                                                                                            }}
                                                                                        >{subItem.title}</span>
                                                                                    </span>

                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                ) : (
                                                    <span
                                                        className='text-[#045662] border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold'
                                                        aria-expanded="true"
                                                        onClick={() => {
                                                            // if (item?.title == 'Evolution') {
                                                            //     CreateAndLaunchWCOCasino('EVZ', '', 'EV')
                                                            //     setLeftMenu(false)
                                                            //     setOpenMenus({})
                                                            // }
                                                            // else {
                                                            //     navigate(item?.url)
                                                            //     setLeftMenu(false)
                                                            //     setOpenMenus({
                                                            //     })
                                                            // }
                                                            navigate(item?.url)
                                                            setLeftMenu(false)
                                                            setOpenMenus({})
                                                        }}
                                                    >
                                                        <img
                                                            className={item.icon.endsWith('.svg') ? 'w-[18px] mr-[5px]' : 'w-[28px] mr-1'}
                                                            src={item.icon}
                                                        />
                                                        {item.title}
                                                    </span>
                                                )}
                                            </li>
                                        ))}
                                    </>
                                )
                            :
                            <>
                                <p className='bg-[#27a6c3] text-[#fff] h-[30px] text-[14px] font-bold capitalize py-[2px] px-[7px]'>
                                    <button type='button' onClick={() => setLeftMenu(false)} className='float-right'>
                                        <i className="fa fa-close pt-1 icon-toggle-right  lg:hidden  float-right"></i>
                                    </button>
                                </p>
                                {
                                    navItems.map((item, index) => (
                                        <>
                                            <li key={index} className='sidebar-li'>
                                                {item.submenu ? (
                                                    <>
                                                        <a onClick={() => toggleMenu(item.title)} className="dropdown-toggle text-[#045662]  border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold capitalize" >
                                                            {item.title}
                                                        </a>
                                                        {
                                                            openMenus[item.title] &&
                                                            <div className='block' id="cricketSubmenu">
                                                                <div className='bg-[#e1e4ef] text-[12px] py-[2px] px-[5px]'>
                                                                    <ul className=''>
                                                                        {item?.submenu?.map((subItem, index) => (
                                                                            <li key={index} className='ml-[15px]' onClick={() => toggleSubMenu(subItem.title)}>
                                                                                <div className='relative pt-[4px] overflow-ellipsis whitespace-nowrap overflow-hidden align-middle'>
                                                                                    <span className='uppercase font-[monospace] text-[0.6em] align-middle mr-0'></span>
                                                                                    <span >
                                                                                        <span className="text-[11px] text-[rgb(0,_0,_0)] cursor-pointer !border-[#274396] border-l-[1px] !pt-[4px] !pr-[0] !pb-[0] !pl-[10px] table-caption !whitespace-normal w-[125px]" onClick={() => {
                                                                                            navigate(subItem?.url)
                                                                                            setLeftMenu(false)
                                                                                            setOpenMenus({})
                                                                                        }} >{subItem.title}</span>
                                                                                    </span>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                ) : (
                                                    <span
                                                        className='text-[#045662] border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold'
                                                        aria-expanded="true"
                                                        onClick={() => {
                                                            navigate(item?.url)
                                                            setLeftMenu(false)
                                                            setOpenMenus({})
                                                        }}
                                                    >

                                                        {item.title}
                                                    </span>
                                                )}
                                            </li>

                                        </ >
                                    ))

                                }

                                <li className='sidebar-li'>
                                    <span
                                        className='text-[#045662] border-[#e8e8e8] border-b-[1px] flex items-center py-[8px] px-[10px] text-[14px] font-bold'
                                        aria-expanded="true"
                                        onClick={() => {
                                            dispatch(logout());
                                            navigate('/');
                                            setLeftMenu(false)
                                            setOpenMenus({})
                                        }}
                                    >
                                        Logout
                                    </span>
                                </li>
                            </>
                    }
                </ul>
            </div >
        </>
    )
}


export default LeftSidebar;
